import { render, staticRenderFns } from "./CreditNoteContent.vue?vue&type=template&id=3c955470&scoped=true&"
import script from "./CreditNoteContent.vue?vue&type=script&lang=js&"
export * from "./CreditNoteContent.vue?vue&type=script&lang=js&"
import style0 from "./CreditNoteContent.vue?vue&type=style&index=0&id=3c955470&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c955470",
  null
  
)

export default component.exports